module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NDAiIGhlaWdodD0iMjU0IiB2aWV3Qm94PSIwIDAgNTQwIDI1NCI+PHJlY3Qgd2lkdGg9IjUzOSIgaGVpZ2h0PSIyNTMuMTA1IiB4PSIxMTkuMzI3IiB5PSI2NDIwIiBmaWxsPSIjRjBFOUZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHJ4PSI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE5IC02NDIwKSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/complete-bg.svg
// module id = ubbU
// module chunks = 0